
/**
 * Module dependencies.
 */

import { toLower, toUpper, upperFirst } from 'lodash';

/**
 * Export `interpolationConfig`.
 */

export const interpolationConfig = {
  escapeValue: false,
  format(value: any, format: string | undefined) {
    if (format) {
      switch (format) {
        case 'capitalize':
          return upperFirst(value);

        case 'lowercase':
          return toLower(value);

        case 'uppercase':
          return toUpper(value);

        default:
          return value;
      }
    }

    return value;
  }
};
